import { Injectable } from '@angular/core';

import { DateTime } from 'luxon';

import { APP_DATA_KEYS } from '../constants/app-data.constants';

import { MaatWorkingDayCalculator, WorkingDayDefinition } from '../helpers/maat-working-day-calculator';

import { AppDataService } from './app-data.service';

@Injectable({
  providedIn: 'root'
})
export class PublicHolidayService {

  private readonly maatWorkingDateCalculator: MaatWorkingDayCalculator;

  constructor(
    private appDataService: AppDataService) {

    this.maatWorkingDateCalculator = new MaatWorkingDayCalculator(() => this.getPublicHolidayDates());
  }

  getPublicHolidayDates(): DateTime[] {
    return this.appDataService.getAppData<DateTime[]>(APP_DATA_KEYS.publicHolidayDates);
  }

  addWorkingDaysFromHours(inputDate: DateTime, hoursToAdd: number, workingDayDefinition: WorkingDayDefinition): DateTime {
    return this.maatWorkingDateCalculator.addWorkingDaysFromHours(inputDate, hoursToAdd, workingDayDefinition);
  }
}
